import React from 'react'
import DailyPuzzleIcon from '../../../../sharedComponents/src/globalHeader/icons/daily_puzzle'
import PuzzleTitle from '../../components/PuzzleTitle'

const DailyPuzzleTitle: React.FC = () => {
    return <PuzzleTitle icon={<DailyPuzzleIcon />} title="Daily Puzzle" />
}

export default DailyPuzzleTitle
